
import { importSync as i } from '@embroider/macros';
let d = window.define;
import "ember-modifier/-embroider-implicit-modules.js";
import "ember-modifier-manager-polyfill/-embroider-implicit-modules.js";
import "ember-destroyable-polyfill/-embroider-implicit-modules.js";
